/**
 * @generated SignedSource<<b266906341c5ff88ac5477021fb4f178>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateOutlookVerificationKeyInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateOutlookVerificationKeyMutation$variables = {
  input: CreateOutlookVerificationKeyInput;
};
export type CreateOutlookVerificationKeyMutation$data = {
  readonly createOutlookVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type CreateOutlookVerificationKeyMutation = {
  variables: CreateOutlookVerificationKeyMutation$variables;
  response: CreateOutlookVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOutlookVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createOutlookVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOutlookVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateOutlookVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1af5c977f509f4442ff8aa035c136c43",
    "id": null,
    "metadata": {},
    "name": "CreateOutlookVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation CreateOutlookVerificationKeyMutation(\n  $input: CreateOutlookVerificationKeyInput!\n) {\n  createOutlookVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "1a9af3ad49bea7c856cad2a22ee1e136";

export default node;
